export * from './close-confirm-icon.component';